import React, { useRef } from 'react';
import './Checkbox.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logComponent from '../../common/logComponent';

export default function Checkbox({ onChange, option, name, checked }) {
  if (logComponent('Checkbox')) { console.debug('Checkbox rendered'); }

  const nativeCheckboxRef = useRef(null);
  const handleChange = (e) => {
    if (logComponent('Checkbox')) { console.debug('Checkbox handleChange'); }
    onChange(option);
  }

  const setNativeCheckboxRef = (el) => {
    if (logComponent('Checkbox')) { console.debug('Checkbox setNativeCheckboxRef'); }
    nativeCheckboxRef.current = el;
  }  

  const clickNativeCheckbox = () => {
    if (logComponent('Checkbox')) { console.debug('Checkbox clickNativeCheckbox'); }
    if (nativeCheckboxRef.current) nativeCheckboxRef.current.click();
  }


  return (
    <div className="Checkbox">
      <input 
        ref={setNativeCheckboxRef}
        type="checkbox"
        className="Checkbox__native-checkbox"
        id={option.text.toLowerCase() + '-input'}
        name={option.text.toLowerCase()}
        checked={checked}
        onChange={handleChange} />
      <div className="Checkbox__outline" onClick={clickNativeCheckbox}>
        <FontAwesomeIcon className={'Checkbox__check' + (checked ? ' visible' : '')} icon="check"></FontAwesomeIcon>
      </div>
      <label
      className="Checkbox__label"
      htmlFor={name + '-input'}>
        { option.text }
      </label>
    </div>
  );
}